"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsDropzone = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const className_1 = require("../../utils/className");
exports.SmlsDropzone = ({ id, disabled = false, cbOnFilesAdded, collapsed = false, acceptAllMIMETypes = false, textDesktop, textMobile, textDesktopDrop, extensions = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'], textExtensions = '(.jpg, .jpeg, .png ou .pdf)', className = '', }) => {
    const [highlight, setHighlight] = react_1.useState(false);
    const [isDesktop, setIsDesktop] = react_1.useState(false);
    const fileInputRef = react_1.useRef(null);
    const MimeTypes = react_1.useMemo(() => {
        if (acceptAllMIMETypes)
            return '';
        return extensions.join(', ');
    }, [extensions, acceptAllMIMETypes]);
    const verifyIfIsDesktop = react_1.useCallback((width, height) => {
        if (width < 600 || height < 600)
            setIsDesktop(false);
        else
            setIsDesktop(true);
    }, []);
    // TO DO : resize listener in custom hooks
    react_1.useEffect(() => {
        verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        window.addEventListener('resize', () => {
            verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        });
    }, [verifyIfIsDesktop]);
    function fileListToArray(list) {
        const array = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < list.length; i++) {
            array.push(list.item(i));
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        if (acceptAllMIMETypes)
            return array;
        const arrayFiltered = array.filter((file) => extensions.some((el) => el === (file === null || file === void 0 ? void 0 : file.type)));
        return arrayFiltered;
    }
    function openFileDialog() {
        if (disabled)
            return;
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }
    function onFilesAdded(event) {
        if (disabled)
            return;
        const files = event.target.files;
        if (cbOnFilesAdded) {
            const array = fileListToArray(files);
            cbOnFilesAdded(array);
        }
    }
    function onDragOver(event) {
        event.preventDefault();
        if (disabled)
            return;
        setHighlight(true);
    }
    function onDragLeave() {
        setHighlight(false);
    }
    function onDrop(event) {
        event.preventDefault();
        if (disabled)
            return;
        const files = event.dataTransfer.files;
        if (cbOnFilesAdded) {
            const array = fileListToArray(files);
            cbOnFilesAdded(array);
        }
        setHighlight(false);
    }
    return (react_1.default.createElement("div", { id: id, className: className_1.mapToCssModules([
            'smls-dropzone',
            highlight ? 'highlight' : '',
            isDesktop && !collapsed ? 'full' : '',
            disabled ? 'disabled' : '',
            className,
        ]), onDragOver: onDragOver, onDragLeave: onDragLeave, onDrop: onDrop, onClick: openFileDialog, style: { cursor: disabled ? 'default' : 'pointer' } },
        react_1.default.createElement("input", { ref: fileInputRef, disabled: disabled, className: "file-input", type: "file", accept: MimeTypes, multiple: true, onChange: onFilesAdded }),
        !highlight && react_1.default.createElement("i", { className: "material-icons" }, "attach_file"),
        react_1.default.createElement("div", { className: "text-default" }, highlight ? (react_1.default.createElement("span", null, textDesktopDrop)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", null, isDesktop ? textDesktop : textMobile),
            react_1.default.createElement("span", null, textExtensions))))));
};
//# sourceMappingURL=index.js.map